import React, { useContext, createContext } from 'react';
import useCart from './use';

const CartContext = createContext({});
const useCartContext = () => useContext(CartContext);

const CartContextProvider = ({ children }) => {
    const cart = useCart();

    return (
        <CartContext.Provider value={cart}>
            {children}
        </CartContext.Provider>
    );
};

export default CartContextProvider;
export { useCartContext };